import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../service'

export const useListInfographicReportRuns = (body = {}, options = {}) => {
  const { mapper = null, enabled = true } = options ?? {}
  return useQuery({
    queryKey: ['reports', 'listInfographicReportRuns', body],
    queryFn: async () => {
      const { data } = await postNamedQuery('reports', 'list-infographic-report-runs', body)
      return data
    },
    enabled,
    mapper: mapper ?? ((data) => data?.data ?? [])
  })
}
